/**
 * The ONE reader of a StorageService-written value (review 7 SHARED-URL round 3): `StorageService.store` writes
 * `JSON.stringify(value)` under `<prefix>-<key>`, and this is the read half, shared by `StorageService.get` (the DI
 * service every caller uses) and the DI-free `utils/edge-owner.ts` (the editors' rebuild, which must not pull the
 * service graph into its module evaluation). No second parser anywhere: a change to the storage format lands here.
 */
export const USER_SETTING_KEY_PREFIX = 'USER_SETTING_PREFIX';
/** `LoginServiceConstants.AUTH_BEARER_STORAGE_KEY`: where `AuthService` keeps this browser's bearer. */
export const AUTH_BEARER_STORAGE_KEY = 'AUTH';

export function storedKeyOf(prefix: string, key: string): string {
    return `${prefix}-${key}`;
}

/** The parsed value under `<prefix>-<key>`, or null when absent, unparseable or the storage is unavailable. */
export function readStoredJson<T = unknown>(storage: Pick<Storage, 'getItem'> | null | undefined, prefix: string, key: string): T | null {
    try {
        const raw = storage?.getItem(storedKeyOf(prefix, key));
        if (!raw) return null;
        return JSON.parse(raw) as T; // StorageService.store always writes JSON; this should not fail for any type
    } catch {
        return null;
    }
}
